<template>
  <div>
    <section aria-labelledby="notes-title">
      <div>
        <div class="mt-6 flex justify-end">
          <div class="flex">
            <TButton
              class="ml-2"
              v-if="contact.activities.length > notesIndex"
              label="Show All"
              color="white"
              @click="notesIndex = notesIndex + 999999"
            >
            </TButton>
            <TButton
              class="ml-2"
              v-else-if="contact.activities.length > 5"
              label="Show Less"
              color="white"
              @click="notesIndex = 5"
            >
            </TButton>
          </div>
        </div>
        <div class="mt-6">
          <ul role="list" class="divide-y divide-gray-200">
            <li v-for="activity of contact.activities.slice(0, notesIndex)" :key="activity.id" class="py-4">
              <div v-if="activity.activityType == 'note'" class="flex space-x-3">
                <div>
                  <div class="text-sm">
                    <div class="font-medium text-gray-900">
                      {{ formattedNoteTitle(activity) }}
                    </div>
                  </div>
                  <div class="mt-1 text-sm text-gray-700 user-generated-content">
                    <div v-html="sanitize(activity.content)"></div>
                  </div>
                  <div class="mt-2 space-x-2 text-sm flex">
                    <span class="font-medium text-gray-500">{{ fromNow(activity.created_at) }} ago |</span>
                    <span @click="deleteNote(activity.id)" class="cursor-pointer font-medium text-gray-500"
                      >delete</span
                    >
                  </div>
                </div>
              </div>
              <div v-if="activity.activityType == 'email'" class="flex space-x-3">
                <TeammateEmailHistoryPreview :email="activity" />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-6 sm:px-6">
        <div class="flex space-x-3">
          <div class="min-w-0 flex-1">
            <QuillInput
              name="activity"
              label="Activity"
              v-model="contactNote.content"
              :labelSrOnly="true"
              size="large"
            />
            <div class="mt-3 flex items-center justify-end gap-1">
              <SelectMenu
                v-model="contactNote.noteType"
                :options="['General note', 'Log a call', 'Log an email', 'Log a text']"
                initialValue="General note"
                @input="val => (contactNote.noteType = val)"
              />
              <TButton label="Save" color="indigo" @click="createNote()">
                <LocalLoadingSpinner />
              </TButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TeammateEmailHistoryPreview from './TeammateEmailHistoryPreview.vue';
import { sanitizeRichText } from '../../utilities/sanitization.js';
import SelectMenu from '../shared/SelectMenu.vue';
import DateUtility from '../../utilities/dates';
import QuillInput from '../shared/QuillInput.vue';

export default {
  props: ['contact'],
  components: {
    TeammateEmailHistoryPreview,
    SelectMenu,
    QuillInput,
  },
  data() {
    return {
      contactNote: {
        content: '',
        followupAt: '',
        noteType: 'general',
      },
      notesIndex: 5,
    };
  },
  methods: {
    ...DateUtility,
    sanitize(html) {
      return sanitizeRichText(html);
    },
    createNote() {
      const self = this;
      if (this.contactNote.noteType === 'General note') {
        this.contactNote.noteType = 'general';
      } else if (this.contactNote.noteType === 'Log a call') {
        this.contactNote.noteType = 'call';
      } else if (this.contactNote.noteType === 'Log an email') {
        this.contactNote.noteType = 'email';
      } else if (this.contactNote.noteType === 'Log a text') {
        this.contactNote.noteType = 'text';
      }

      self.$store.commit('general/showLocalLoadingSpinner');
      fetch('/api/contact_notes', {
        method: 'POST',
        body: JSON.stringify({
          contact_id: self.contact.id,
          content: self.contactNote.content,
          followup_at: self.contactNote.followupAt,
          note_type: self.contactNote.noteType,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$emit('activityCreated');
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.contactNote.content = '';
            self.contactNote.followupAt = '';
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Note created',
              alertDescription:
                'Your candidate note was successfully created.  Use the buttons below to view your new contact, or dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Note create error',
              alertDescription: data.message,
            });
          }
        });
    },
    deleteNote(id) {
      const self = this;
      fetch(`/api/contact_notes/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$emit('activityDeleted');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Activity deleted',
              alertDescription:
                'Your activity was successfully deleted.  Use the buttons below to view your new contact, or dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Activity delete error',
              alertDescription: data.message,
            });
          }
        });
    },
    formattedNoteTitle(note) {
      const t = note.note_type;
      const displayName = note.user.name ? note.user.name : note.user.email;
      if (t === 'general') {
        return `${displayName} left a note`;
      } else if (t === 'call') {
        return `${displayName} logged a call`;
      } else if (t === 'email') {
        return `${displayName} logged an email`;
      } else if (t === 'text') {
        return `${displayName} logged a text`;
      }
      return note.user.email;
    },
  },
};
</script>
